<template lang="pug">
base-container
  avue-crud(
    ref="crud",
    :data="data",
    :table-loading="loading",
    :option="option",
    :page.sync="page",
    @row-update="handleFeedback",
    @search-change="searchChange",
    @search-reset="searchReset",
    @current-change="currentChange",
    @size-change="sizeChange",
    @refresh-change="refreshChange",
    @on-load="onLoad"
  )
    template(slot="tripStatus", slot-scope="scope")
      el-tag {{ findTagLabel(scope.row.tripStatus) }}
    template(slot-scope="scope", slot="menu")
      el-button.none-border(
        v-if="scope.row.hasFeedback === 2",
        icon="el-icon-view",
        type="text",
        size="small",
        plain,
        @click.stop="rowView(scope.row, scope.index)"
      ) 查看反馈
      el-button.none-border(
        v-if="scope.row.hasFeedback === 1 ",
        icon="el-icon-edit",
        type="text",
        size="small",
        plain,
        @click.stop="rowEdit(scope.row, scope.index)"
      ) 反馈处理
</template>
<script>
/**
 * 内容管理-行程管理-列表
 */
import { find } from 'ramda'
import { getTripList, getTripInfo, doTripHandle } from '@/api/trip'
import { tripStatusEnum, feedbackTypeEnum, handleResultEnum } from './const'
export default {
  name: 'Trip',
  components: {},
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        indexLabel: '编号',
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        editBtnText: '更新',
        editTitle: '反馈处理',
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchSpan: 8,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 160,
        menu: true,
        column: [
          {
            label: '昵称',
            prop: 'nickname',
            search: true,
            width: 100,
            viewDisplay: false,
            editDisplay: false
          },
          {
            label: '被反馈用户',
            span: 24,
            hide: true,
            prop: 'partnerUsername',
            editDetail: true
          },
          {
            label: '反馈类型',
            span: 24,
            prop: 'feedbackType',
            type: 'select',
            hide: true,
            dicData: feedbackTypeEnum,
            editDetail: true
          },
          {
            label: '反馈内容',
            span: 24,
            type: 'textarea',
            minRows: 2,
            hide: true,
            prop: 'feedbackContent',
            editDetail: true
          },
          {
            label: '反馈图片',
            span: 24,
            hide: true,
            prop: 'feedbackPics',
            type: 'upload',
            listType: 'picture-card',
            dataType: 'string',
            editDetail: true
          },
          {
            label: '处理结果',
            span: 24,
            hide: true,
            prop: 'handleResult',
            type: 'radio',
            border: true,
            dicData: handleResultEnum,
            editDetail: false,
            editDisplay: true
          },
          {
            label: '手机号',
            prop: 'mobile',
            search: true,
            width: 120,
            viewDisplay: false,
            editDisplay: false
          },
          {
            label: '邮箱',
            prop: 'email',
            search: true,
            width: 120,
            viewDisplay: false,
            editDisplay: false
          },
          {
            label: '行程状态',
            prop: 'tripStatus',
            type: 'select',
            slot: true,
            dicData: tripStatusEnum,
            viewDisplay: false,
            editDisplay: false,
            width: 100
          },
          {
            label: '目的地',
            prop: 'arrival',
            overHidden: true,
            editDisplay: false,
            viewDisplay: false,
            width: 150
          },
          {
            label: '出游时间',
            prop: 'tripStartDate',
            type: 'daterange',
            search: true,
            searchRange: true,
            sortable: true,
            valueFormat: 'yyyy-MM-dd hh:mm:ss',
            editDisplay: false,
            viewDisplay: false,
            width: 200
          },
          {
            label: '结束时间',
            prop: 'tripEndDate',
            type: 'daterange',
            sortable: true,
            editDisplay: false,
            viewDisplay: false,
            width: 200
          }
        ]
      }
    }
  },
  methods: {
    findTagLabel(field) {
      return find((x) => x.value === field)(tripStatusEnum).label
    },
    rowView(row, index, loading, done) {
      getTripInfo({ id: row.id }).then((res) => {
        row = { ...row, ...res.data }
        this.$refs.crud.rowView(row, index, loading, done)
      })
    },
    rowEdit(row, index, loading, done) {
      getTripInfo({ id: row.id }).then((res) => {
        row = { ...row, ...res.data }
        this.$refs.crud.rowEdit(row, index, loading, done)
      })
    },
    handleFeedback(row, index, loading, done) {
      let { id, handleResult } = row
      if (handleResult === 2) {
        handleResult = 0
      }
      this.$confirm('确定更新该数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          doTripHandle({ id, opt: handleResult }).then((res) => {
            loading()
            this.onLoad(this.page)
            if (res.code === '00000') {
              this.$message({
                type: 'success',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          loading()
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { tripStartDate } = params
      let values = { ...params }
      if (tripStartDate) {
        values = {
          ...params,
          tripDateStart: tripStartDate[0],
          tripDateEnd: tripStartDate[1]
        }
        values.tripStartDate = tripStartDate[0]
        this.query.tripStartDate = null
      }
      this.loading = true
      getTripList(page.currentPage, page.pageSize, { ...this.query, ...values })
        .then((res) => {
          const data = res.data
          this.page.total = res.total
          this.data = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
